import { useEffect, useState } from 'react';
import { Icon } from '../shared';

interface ForgotPasswordFormProps {
  onSuccess?: () => void;
  onCancel?: () => void;
  switchToLogin?: () => void;
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  onSuccess,
  onCancel,
  switchToLogin,
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return;
    }
    const timer = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleCopyHint = async () => {
    try {
      await navigator.clipboard.writeText('请登录后进入个人中心 -> 设置 -> 修改密码');
      setCopied(true);
      onSuccess?.();
    } catch (error) {
      console.error('[ForgotPasswordForm] 复制提示失败:', error);
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-[#dc2626] border-4 border-[#5d3a1a] shadow-[4px_4px_0px_0px_rgba(93,58,26,0.3)] mb-3 jagged-corners">
          <Icon name="lock_reset" className="w-8 h-8 text-white" />
        </div>
        <h2 className="text-xl font-black text-[#5d3a1a] dark:text-[#deb887]">重置密码</h2>
        <p className="text-sm text-[#8b4513] font-bold mt-1">自托管首版暂未开放邮箱验证码重置</p>
      </div>

      <div className="bg-[#fffaf0] dark:bg-[#3e2723] border-[3px] border-[#8b4513] p-4 space-y-3 shadow-[3px_3px_0px_0px_rgba(93,58,26,0.2)]">
        <p className="text-sm text-[#5d3a1a] dark:text-[#deb887] font-bold leading-6">
                当前自托管版本暂不支持邮件自助重置密码，请在已登录状态下修改密码。
        </p>
        <p className="text-sm text-[#8b4513] dark:text-[#d2b48c]">
          如果你仍然能登录，请前往“个人中心 - 设置 - 修改密码”完成修改。
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={handleCopyHint}
            className="px-4 py-2 bg-[#deb887] hover:bg-[#c19a6b] text-[#5d3a1a] font-bold border-[3px] border-[#8b4513] shadow-[2px_2px_0px_0px_rgba(93,58,26,0.3)]"
          >
            {copied ? '已复制提示' : '复制处理建议'}
          </button>
          {switchToLogin && (
            <button
              type="button"
              onClick={switchToLogin}
              className="px-4 py-2 bg-[#5d3a1a] hover:bg-[#704214] text-white font-bold border-[3px] border-[#3e2723] shadow-[2px_2px_0px_0px_rgba(62,39,35,0.3)]"
            >
              返回登录
            </button>
          )}
        </div>
      </div>

      <div className="flex justify-center gap-4 pt-2">
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="text-[#8b4513] dark:text-[#deb887] hover:text-[#5d3a1a] dark:hover:text-[#f5deb3] font-bold text-sm underline decoration-2 underline-offset-4"
          >
            取消
          </button>
        )}
        {switchToLogin && (
          <button
            type="button"
            onClick={switchToLogin}
            className="text-[#8b4513] dark:text-[#deb887] hover:text-[#5d3a1a] dark:hover:text-[#f5deb3] font-bold text-sm underline decoration-2 underline-offset-4"
          >
            返回登录
          </button>
        )}
      </div>
    </div>
  );
};
